var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _circle, _circle2, _circle3, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 706.94 597.04",
    id: "web-security",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 94.66,
    x2: 216.08,
    y1: 38.77,
    y2: 38.77,
    gradientTransform: "matrix(1 0 0 -1 -66.11 598)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#183866"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a7fc1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 338.91,
    x2: -419.55,
    y1: 322.38,
    y2: 287.33,
    gradientTransform: "matrix(1 0 0 -1 -66.11 598)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#0c0c11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#312f43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#3f3d56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 54.26,
    x2: 397.83,
    y1: 211.88,
    y2: 265.39,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 87.57,
    x2: 330.28,
    y1: 226.99,
    y2: 241.6,
    gradientTransform: "matrix(1 0 0 -1 -66.11 598)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#0c0c11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#312f43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#3f3d56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 278.82,
    x2: 149.37,
    y1: 79.48,
    y2: 258.72,
    gradientTransform: "matrix(1 0 0 -1 -66.11 598)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 227.29,
    x2: 70.83,
    y1: 101.18,
    y2: 88.82,
    gradientTransform: "matrix(1 0 0 -1 -66.11 598)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 416.13,
    x2: 424.43,
    y1: 621.1,
    y2: -76.3,
    gradientTransform: "matrix(1 0 0 -1 -66.11 598)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#0c0c11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#312f43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#3f3d56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 157.47,
    x2: 153.06,
    y1: 538.69,
    y2: 510.71,
    gradientTransform: "matrix(1 0 0 -1 -66.11 597.97)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 178.19,
    x2: 173.78,
    y1: 538.69,
    y2: 510.71,
    gradientTransform: "matrix(1 0 0 -1 -66.12 597.98)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 198.89,
    x2: 194.48,
    y1: 538.69,
    y2: 510.71,
    gradientTransform: "matrix(1 0 0 -1 -66.11 597.99)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 445.33,
    x2: 388.26,
    y1: 528.04,
    y2: 165.69,
    gradientTransform: "matrix(1 0 0 -1 -66.11 598)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 412.42,
    x2: 411.09,
    y1: 446.49,
    y2: 361.45,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 574.14,
    x2: 695.58,
    y1: 228.35,
    y2: 110.56,
    gradientTransform: "matrix(1 0 0 -1 -66.11 598)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 610.2,
    x2: 469.84,
    y1: 103.53,
    y2: 222.54,
    gradientTransform: "matrix(1 0 0 -1 -66.11 598)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 615.98,
    x2: 827.13,
    y1: 96.1,
    y2: 149.8,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 599.82,
    x2: 762.77,
    y1: 182.75,
    y2: 288.33,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 619.9,
    x2: 765.75,
    y1: 228.79,
    y2: 186.07,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: -454.11,
    x2: -419.1,
    y1: -544.69,
    y2: -544.69,
    gradientTransform: "matrix(.97 .25 .25 -.97 1111.5 -91.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ecc4d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#efd4d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2eac9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 598.25,
    x2: 710.18,
    y1: 289.99,
    y2: 331.78,
    gradientTransform: "matrix(1 0 0 -1 -66.11 598)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 608.77,
    x2: 685.27,
    y1: 278.48,
    y2: 283.61,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: -441.42,
    x2: -398.9,
    y1: -558.23,
    y2: -576.69,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 550.81,
    x2: 542.86,
    y1: 217.57,
    y2: -33.73,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 606.39,
    x2: 598.44,
    y1: 216.99,
    y2: -34.31,
    xlinkHref: "#d"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M149.65 552c1.26 3.32-1.34 7-4.52 8.58s-6.86 1.72-10.3 2.61c-5.35 1.38-10.06 4.52-15.24 6.45-7.11 2.65-14.85 2.94-22.44 3.2-22.9.79-47.34 1.18-66.8-10.92a3.72 3.72 0 0 1-1.69-1.68 3 3 0 0 1 .21-2.17c1.61-3.71 6.23-4.84 10.23-5.47 18.84-2.94 38.13-5.6 57.21-6.27 9.92-.33 49.58-4.27 53.34 5.67Z",
    opacity: 0.19,
    transform: "translate(-.01 -.02)",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1d2741",
    d: "M542.81 553.5c-8.67 1.76-16.84 5.37-24.93 9l-32.45 14.37c18.1 9.74 40.07 5.72 60.63 5.44 1.8 0 3.74 0 5.17 1.12 2 1.57 2.18 4.54 3.43 6.78 2.35 4.24 8 5.09 12.83 5.41a677.74 677.74 0 0 0 131.12-4.18c2.08-.27 4.26-.59 5.94-1.84 5-3.73 1.48-12.34-4.18-15s-12.31-2-18.32-3.72-11.81-8.08-9-13.69q-37.17.73-74.34-.8c-18.71-.8-37.23-6.69-55.9-2.89Z",
    opacity: 0.18,
    transform: "translate(-.01 -.02)",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "M662.29 337.35c4.06-42.35 24.67-87.15 3.6-125.44-5.53-10-13.46-18.57-22.33-26.54-11.72-10.51-25.07-20-36.74-30.59-20.65-18.72-32.46-41.19-48.37-61.75a153.22 153.22 0 0 0-22.37-23.73q-4.94-4.17-10-8.21c-27.66-21.91-58.79-40.72-94.19-51.64C381.69-6 322-3.51 279.62 24.69c-15.26 10.15-27.62 23.05-39.54 36.4-9.62 10.77-18.91 21.83-29.19 31.91-9.19 9.08-19.15 17.4-30.78 24.07-16.56 9.51-35.62 15.1-53.19 23.09a182.8 182.8 0 0 0-32 18.67 179.2 179.2 0 0 0-35.69 34.38C37 221.55 24.44 255.7 25.29 290.08c.13 5.38.57 10.79.74 16.19A78.47 78.47 0 0 1 25 324c-1.86 9.6-6.43 18.62-11.15 27.56C7.43 363.75.7 375.79.06 389c-1.12 22.74 15.72 42.22 34.4 58.87 3.12 2.78 6.3 5.49 9.44 8.12 5 4.2 10.15 8.4 15.34 12.55l1 .8c2.78 2.21 5.57 4.41 8.4 6.59 7.1 5.47 14.37 10.8 21.82 15.88q5 3.39 10 6.59c7.79 5 15.78 9.57 24 13.74 20.31 10.32 42 17.86 65.34 20.86 63.93 8 127.52-20.43 192-16.67 42.31 2.46 81.77 18.6 122.77 28s88.61 10.9 121.67-12.33c30.47-21.37 40.46-58.29 40.54-92.43s-7.73-68.19-4.49-102.22Z",
    opacity: 0.18,
    transform: "translate(-.01 -.02)",
    style: {
      isolation: "isolate"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "M615.88 61.07h-529a27.61 27.61 0 0 0-27.65 27.57v380.69H643.5V88.68a27.61 27.61 0 0 0-27.61-27.61Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M165.11 407.85c-1 10.43-10.36 18.09-20 21.37-5 1.7-10.31 2.65-14.6 5.75s-7.1 9.37-4.4 14a16.35 16.35 0 0 1 15.26 10.29c-6.17 9.39-17.1 14.52-28 16s-22-.26-32.8-2.06c-3.79-.62-7.83-1.38-10.56-4.16s-3.48-6.82-4.16-10.65c-.09-.54-.19-1.08-.29-1.63H59V93h35.81v173c0 14.11-.64 28.34-.42 42.4.22 13.38 9.12 20.16 17.6 29.89 2.61 3 5.32 6.18 6.09 10.13.83 4.19-.67 8.63.44 12.74 1.92 7.14 10.91 9.84 17.81 7.82s12.43-7.22 18.38-11.36a67.18 67.18 0 0 1 34.85-11.89c-4.19 17.77-24.8 29-25.28 47.31-.15 4.96 1.31 9.86.83 14.81Z",
    opacity: 0.47,
    transform: "translate(-.01 -.02)",
    style: {
      isolation: "isolate"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "M33.78 423.51c-9-14.55-15.3-30.9-17.09-47.91-1.1-10.37-.63-21.31-5.31-30.63-2.78-5.54-7.31-10.3-8.71-16.35-2.6-11.3 6.47-21.63 14.8-29.7a3.85 3.85 0 0 1 1.92-1.24c1.3-.24 2.47.84 3.26 1.91 4.77 6.43 5.15 15 6.37 22.87 1.31 8.55 4.11 17.39 10.62 23.1s16.54 8.22 19.75 16.28c2.85 7.18-1.24 15.65 1.33 22.94s11.36 11.66 12.68 19.34c.88 5.1-1.86 10.16-1.78 15.33.06 3.94 1.75 7.65 2.71 11.48 2.06 8.22 0 32.29-12.49 25.25-11.31-6.35-21.42-21.94-28.06-32.67Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M33.79 423.53c-9-14.55-15.3-30.9-17.09-47.91-1.1-10.37-.63-21.31-5.31-30.63-2.78-5.54-7.31-10.3-8.71-16.35-2.6-11.3 6.47-21.63 14.8-29.7a3.85 3.85 0 0 1 1.92-1.24c1.3-.24 2.47.84 3.26 1.91 4.77 6.43 5.15 15 6.37 22.87 1.31 8.55 4.11 17.39 10.62 23.1s16.54 8.22 19.75 16.28c2.85 7.18-1.24 15.65 1.33 22.94s11.36 11.66 12.68 19.34c.88 5.1-1.86 10.16-1.78 15.33.06 3.94 1.75 7.65 2.71 11.48 2.06 8.22 0 32.29-12.49 25.25-11.31-6.35-21.42-21.94-28.06-32.67Z",
    transform: "translate(-.01 -.02)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "M56.48 406.98c-3.27-16.78-3.38-34.32 1-50.86 2.65-10.09 7-20.15 5.87-30.52-.64-6.17-3.2-12.23-2.36-18.37 1.57-11.49 13.7-18 24.34-22.56a4 4 0 0 1 2.24-.48c1.31.24 2 1.66 2.37 2.94 2.19 7.7-.47 15.82-2.13 23.65-1.79 8.46-2.3 17.72 1.76 25.36s12.57 13.54 12.72 22.21c.13 7.73-6.69 14.21-6.86 21.93s6.5 14.92 5 22.58c-1 5.08-5.34 8.84-7.09 13.7-1.34 3.71-1.07 7.78-1.52 11.7-1 8.42-11.38 30.23-20.62 19.2-8.32-9.96-12.32-28.11-14.72-40.48Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M56.49 407c-3.27-16.78-3.38-34.32 1-50.86 2.65-10.09 7-20.15 5.87-30.52-.64-6.17-3.2-12.23-2.36-18.37 1.57-11.49 13.7-18 24.34-22.56a4 4 0 0 1 2.24-.48c1.31.24 2 1.66 2.37 2.94 2.19 7.7-.47 15.82-2.13 23.65-1.79 8.46-2.3 17.72 1.76 25.36s12.57 13.54 12.72 22.21c.13 7.73-6.69 14.21-6.86 21.93s6.5 14.92 5 22.58c-1 5.08-5.34 8.84-7.09 13.7-1.34 3.71-1.07 7.78-1.52 11.7-1 8.42-11.38 30.23-20.62 19.2-8.32-9.96-12.32-28.11-14.72-40.48Z",
    transform: "translate(-.01 -.02)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "M79.54 409.77c8.6-14.78 20.07-28 34.23-37.62 8.64-5.85 18.51-10.58 24.53-19.1 3.58-5.06 5.66-11.3 10.33-15.37 8.75-7.61 22.14-4.48 33.18-.92a3.91 3.91 0 0 1 2 1.11c.83 1 .42 2.57-.15 3.78-3.42 7.23-10.78 11.58-17.18 16.38-6.93 5.18-13.41 11.81-15.39 20.23s.53 18.47-5.08 25.09c-5 5.9-14.39 6.27-19.61 12s-4.94 15.51-11.1 20.29c-4.09 3.17-9.84 3.14-14.36 5.64-3.45 1.91-5.93 5.14-8.86 7.79-6.28 5.69-28.47 15.24-28.15.86.27-12.95 9.26-29.26 15.61-40.16Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M79.55 409.79c8.6-14.78 20.07-28 34.23-37.62 8.64-5.85 18.51-10.58 24.53-19.1 3.58-5.06 5.66-11.3 10.33-15.37 8.75-7.61 22.14-4.48 33.18-.92a3.91 3.91 0 0 1 2 1.11c.83 1 .42 2.57-.15 3.78-3.42 7.23-10.78 11.58-17.18 16.38-6.93 5.18-13.41 11.81-15.39 20.23s.53 18.47-5.08 25.09c-5 5.9-14.39 6.27-19.61 12s-4.94 15.51-11.1 20.29c-4.09 3.17-9.84 3.14-14.36 5.64-3.45 1.91-5.93 5.14-8.86 7.79-6.28 5.69-28.47 15.24-28.15.86.27-12.95 9.26-29.26 15.61-40.16Z",
    transform: "translate(-.01 -.02)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "m133.22 461.76-1.34 7.57-1.15 6.59-2.74 15.88-1.09 6.59-2.76 15.89-1.15 6.58-6.86 39.48H44.8l-6.92-39.48-1.15-6.58-2.74-15.89-1.16-6.59-2.84-15.88-1.13-6.59-1.32-7.56a13.1 13.1 0 0 1 10.65-15.17 13.3 13.3 0 0 1 2.27-.2h79.84a13.08 13.08 0 0 1 12.9 15.36Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "m133.23 461.78-1.34 7.57-1.15 6.59-2.74 15.88-1.09 6.59-2.76 15.89-1.15 6.58-6.86 39.48H44.81l-6.92-39.48-1.15-6.58L34 498.41l-1.16-6.59L30 475.94l-1.13-6.59-1.32-7.56a13.1 13.1 0 0 1 10.65-15.17 13.3 13.3 0 0 1 2.27-.2h79.84a13.08 13.08 0 0 1 12.9 15.36Z",
    transform: "translate(-.01 -.02)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M643.51 88.7V93H59.24v-4.3a27.61 27.61 0 0 1 27.61-27.61h529a27.61 27.61 0 0 1 27.62 27.6Z",
    transform: "translate(-.01 -.02)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 88.76,
    cy: 75.84,
    r: 6.17,
    fill: "url(#k)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 109.47,
    cy: 75.84,
    r: 6.17,
    fill: "url(#l)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 130.17,
    cy: 75.84,
    r: 6.17,
    fill: "url(#m)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M417.2 227.05v114.22a14.62 14.62 0 0 1-14.61 14.6H288.38a14.62 14.62 0 0 1-14.61-14.6V227.05a14.6 14.6 0 0 1 14.6-14.6h114.22A14.6 14.6 0 0 1 417.2 227Z",
    transform: "translate(-.01 -.02)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "M357.15 270.52a11.7 11.7 0 0 1-5.85 10.46 3 3 0 0 0-1.5 2.65v25a3.48 3.48 0 0 1-3.48 3.48h-1.7a3.48 3.48 0 0 1-3.48-3.48v-25a3.06 3.06 0 0 0-1.5-2.66 11.68 11.68 0 1 1 17.51-10.45ZM131.91 469.33l-1.15 6.59H30.02l-1.15-6.59h103.04zM127.99 491.8l-1.14 6.59H33.96l-1.16-6.59h95.19zM124.09 514.28l-1.15 6.58H37.88l-1.15-6.58h87.36z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1d2741",
    d: "M494.22 305.91c-4.69-6.57-11.78-11.14-19.33-14-1.72-.65-3.66-1.21-5.34-.48a7.73 7.73 0 0 0-2.87 2.75c-3.64 5-7.43 10.4-7.78 16.58-.52 9.4 6.93 19.41 2.15 27.52-1.33 2.26-3.45 3.94-5 6.06-2.92 4-3.59 9.24-3.2 14.18.47 5.93 1.23 13.86-4.37 15.88a9.62 9.62 0 0 1-5.16.07c-4.91-1-9.45-3.35-14.26-4.75s-10.36-1.73-14.54 1c-.37 5.34 4.22 9.79 9.05 12.1s10.27 3.36 14.7 6.37c6.7 4.54 10 13 9.79 21.13s-3.39 15.83-7.45 22.84c-1.89 3.26-4 6.51-4.78 10.2-1.53 7.36 2.59 14.59 6.54 21 1.16 1.87 2.43 3.85 4.45 4.73a10.92 10.92 0 0 0 5.32.43l70.14-6c2-.17 4.33-.57 5.19-2.38a5.3 5.3 0 0 0 0-3.43c-2.29-9.82-9.5-17.9-12.06-27.66-1.18-4.55-1.31-9.3-1.44-14-.52-19.38-1.17-38.95-5.3-58-2.07-9.49-7.17-18.36-9.19-27.61-1.88-8.63.7-16.19-5.26-24.53Z",
    opacity: 0.18,
    transform: "translate(-.01 -.02)",
    style: {
      isolation: "isolate"
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M384.15 212.45h-12.41v-16.67a26.25 26.25 0 0 0-52.5.13v16.54h-12.42v-17a38.67 38.67 0 0 1 77.32.23Z",
    transform: "translate(-.01 -.02)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "m643.41 545.98 10.47 10-15.07 15.06-18.93 1.63a7 7 0 0 1 3.46-8.55 33 33 0 0 1 11.19-3.66l-.41-7.74ZM527.04 545.21l1.54 12.62-35.46 15.88s-4.43-6.85.11-12.8 17.06-10.13 17.06-10.13l2.21-5.49Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "M536.07 350.56s-12.84 9.49-14.19 24.22-2 19.9-2 19.9l-22.5-1.82-.3 12.44s29.85 10.91 34.43 9.05 10.31-10.07 10.31-10.07Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M536.08 350.58s-12.84 9.49-14.19 24.22-2 19.9-2 19.9l-22.5-1.82-.3 12.44s29.85 10.91 34.43 9.05 10.31-10.07 10.31-10.07Z",
    transform: "translate(-.01 -.02)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "M544.71 429.07s-47 38.78-47.38 52 11.55 64.91 11.55 64.91l18.22-.1.53-54.34s38.44-13.42 42.62-21.53 13.04-47.67-25.54-40.94Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "M544.72 429.09s-47 38.78-47.38 52S508.89 546 508.89 546l18.22-.1.53-54.34s38.44-13.42 42.62-21.53 13.04-47.67-25.54-40.94Z",
    transform: "translate(-.01 -.02)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "M544.71 429.07s2.87 59.14 21.36 78.26 65.81 47.81 65.81 47.81l13.43-8.33-45.43-47.42s6.57-53.23-1.2-62.56-53.97-7.76-53.97-7.76Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M544.72 429.09s2.87 59.14 21.36 78.26 65.81 47.81 65.81 47.81l13.43-8.33-45.43-47.42s6.57-53.23-1.2-62.56-53.97-7.76-53.97-7.76Z",
    transform: "translate(-.01 -.02)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "m544.71 429.07-16.06-67.95s9-25.91 44.67-17.57 25.33 93.28 25.33 93.28-40.04 13.28-53.94-7.76Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "m544.72 429.09-16.06-67.95s9-25.91 44.67-17.57 25.33 93.28 25.33 93.28-40.04 13.28-53.94-7.76Z",
    transform: "translate(-.01 -.02)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "M572.11 353.98s-2.14-11.31 9.34-8.29 29.35 42 28.69 47.42-56.51 7.65-56.51 7.65l-1.33-13 29.36-4.91s-10.78-18.46-9.55-28.87Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "M572.12 354s-2.14-11.31 9.34-8.29 29.35 42 28.69 47.42-56.51 7.65-56.51 7.65l-1.33-13 29.36-4.91s-10.78-18.46-9.55-28.87Z",
    transform: "translate(-.01 -.02)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M566.64 329.88a13.34 13.34 0 0 1-6.61 6.39 9.83 9.83 0 0 0-1.41.61 2.69 2.69 0 0 0-.55.46c-1 1.12-.3 2.78 0 4.22.56 3.28-1.34 6.64-4.08 8.52a17 17 0 0 1-5 2.17c-2.49.65-5.17.8-7.06-.09-3-1.41-2.7-6-3.36-8.81-2.18-9.12-4.09-18.47-3.1-27.9.53-5 1.93-10.1 4.94-14.16s7.8-7 12.86-6.91 9.86 3.28 13.47 7a17.44 17.44 0 0 1 3.16 4.23c2.34 4.69 1.1 10.3-.2 15.38a39.46 39.46 0 0 1-3.06 8.89Z",
    transform: "translate(-.01 -.02)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "M570.65 307.74s-15 0-24.07 5.28c-8.09 4.69-10.32 14.71-11 14.54-1.53-.35-6.52-10-4.42-12.13s.44-2.14.44-2.14-2.41-4-1.2-11.18a114.65 114.65 0 0 1 4.06-15.47s.63-2.38 9.71 0 24.39 9.65 25.24 12.6.15 4.3.15 4.3 2.49 1.83 1.09 4.2Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#s)",
    d: "M570.66 307.76s-15 0-24.07 5.28c-8.09 4.69-10.32 14.71-11 14.54-1.53-.35-6.52-10-4.42-12.13s.44-2.14.44-2.14-2.41-4-1.2-11.18a114.65 114.65 0 0 1 4.06-15.47s.63-2.38 9.71 0 24.39 9.65 25.24 12.6.15 4.3.15 4.3 2.49 1.83 1.09 4.2Z",
    transform: "translate(-.01 -.02)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "M546.58 312.98a113.92 113.92 0 0 0 16 2.68c4.84.31 8.33-1 8.36-1.23.06-.51-1.57 8.12-1.57 8.12l-3.67 1.29a10.07 10.07 0 0 1-4.42.52l-22.89-2.38s3.9-7 8.19-9Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#t)",
    d: "M546.59 313a113.92 113.92 0 0 0 16 2.68c4.84.31 8.33-1 8.36-1.23.06-.51-1.57 8.12-1.57 8.12l-3.67 1.29a10.07 10.07 0 0 1-4.42.52L538.4 322s3.9-7 8.19-9Z",
    transform: "translate(-.01 -.02)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M555.99 317.42a3.41 3.41 0 0 1 2 .06 1.94 1.94 0 0 1 1.13.65 2.41 2.41 0 0 1 .34.85.8.8 0 0 1 0 .53.71.71 0 0 1-.7.23 9.06 9.06 0 0 1-3.48-.67c-.9-.47-.05-1.38.71-1.65ZM566.55 317.91a1.86 1.86 0 0 1 1.39-.47 1.18 1.18 0 0 1 .89.33 2.57 2.57 0 0 1 .39.73 1 1 0 0 1 .1.52.52.52 0 0 1-.43.4 4.59 4.59 0 0 1-2.51.25c-.72-.21-.31-1.31.17-1.76Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#u)",
    d: "M553.94 350.08a17 17 0 0 1-5 2.17 11.34 11.34 0 0 1-2.74-6 31.93 31.93 0 0 1-.53-4.68 5.5 5.5 0 0 1 .94-3.88 4.6 4.6 0 0 1 3.93-1.16c1.41.16 2.77.65 4.18.8 1.2.13 2.64-.42 3.9-.49a2.69 2.69 0 0 0-.55.46c-1 1.12-.3 2.78 0 4.22.51 3.32-1.39 6.68-4.13 8.56Z",
    transform: "translate(-.01 -.02)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "M489.61 386.6a4.24 4.24 0 0 0-2-.87 1.5 1.5 0 0 0-1.64 1.13 2.23 2.23 0 0 0 .49 1.4l1.35 2.11a1.4 1.4 0 0 1 .29.76c0 .7-1 .84-1.71.75-4.4-.56-8.79-1.92-13.18-1.34a1.4 1.4 0 0 0-.91.37 1 1 0 0 0 .11 1.25 2.73 2.73 0 0 0 1.18.67 50.66 50.66 0 0 0 7.55 2.12c-.29.72-1.24.85-2 .88a42 42 0 0 0-6.33.72c-1.19.22-2.65.82-2.66 2a1.9 1.9 0 0 0 1.43 1.68 6.05 6.05 0 0 0 2.36.08 38 38 0 0 1 8.26.21 16.37 16.37 0 0 0-8.13 3.3 1.7 1.7 0 0 0-.52.58c-.27.58.24 1.28.85 1.48a3.71 3.71 0 0 0 1.9-.11 42.42 42.42 0 0 1 8.33-1.08 20.17 20.17 0 0 0-4.68 3 3.38 3.38 0 0 0-1 1.25 1.34 1.34 0 0 0 .26 1.51 1.9 1.9 0 0 0 1.72.14c3.33-.9 6.27-3.06 9.68-3.56 1.78-.27 3.84-.16 5.08-1.47a5.33 5.33 0 0 0 1.08-2.23c.74-2.57 2.27-8 .72-10.5-.61-1-2.09-1.82-3-2.56a58.11 58.11 0 0 0-4.88-3.67ZM545.34 382.5a4.24 4.24 0 0 0-2-.87 1.5 1.5 0 0 0-1.64 1.13 2.23 2.23 0 0 0 .49 1.4l1.35 2.11a1.4 1.4 0 0 1 .29.76c-.05.7-1 .84-1.71.75-4.4-.56-8.79-1.93-13.18-1.34a1.39 1.39 0 0 0-.91.36 1 1 0 0 0 .11 1.26 2.73 2.73 0 0 0 1.18.67 50.66 50.66 0 0 0 7.55 2.12c-.29.72-1.24.84-2 .87a43.36 43.36 0 0 0-6.33.73c-1.19.22-2.65.81-2.66 2a1.9 1.9 0 0 0 1.43 1.68 6.05 6.05 0 0 0 2.36.08 38 38 0 0 1 8.26.21 16.33 16.33 0 0 0-8.12 3.3 1.7 1.7 0 0 0-.53.57 1.2 1.2 0 0 0 .84 1.48 3.61 3.61 0 0 0 1.9-.1 41.68 41.68 0 0 1 8.33-1.08 20.17 20.17 0 0 0-4.68 3 3.38 3.38 0 0 0-1 1.25 1.36 1.36 0 0 0 .26 1.51 1.92 1.92 0 0 0 1.73.14c3.32-.9 6.26-3.06 9.67-3.56 1.78-.27 3.84-.16 5.08-1.47a5.33 5.33 0 0 0 1.08-2.23c.75-2.57 2.27-8 .72-10.51-.61-1-2.09-1.81-3-2.55a58.11 58.11 0 0 0-4.87-3.67Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#v)",
    d: "M489.62 386.62a4.24 4.24 0 0 0-2-.87 1.5 1.5 0 0 0-1.64 1.13 2.23 2.23 0 0 0 .49 1.4l1.35 2.11a1.4 1.4 0 0 1 .29.76c0 .7-1 .84-1.71.75-4.4-.56-8.79-1.92-13.18-1.34a1.4 1.4 0 0 0-.91.37 1 1 0 0 0 .11 1.25 2.73 2.73 0 0 0 1.18.67 50.66 50.66 0 0 0 7.55 2.12c-.29.72-1.24.85-2 .88a42 42 0 0 0-6.33.72c-1.19.22-2.65.82-2.66 2a1.9 1.9 0 0 0 1.43 1.68 6.05 6.05 0 0 0 2.36.08 38 38 0 0 1 8.26.21 16.37 16.37 0 0 0-8.13 3.3 1.7 1.7 0 0 0-.52.58c-.27.58.24 1.28.85 1.48a3.71 3.71 0 0 0 1.9-.11 42.42 42.42 0 0 1 8.33-1.08 20.17 20.17 0 0 0-4.68 3 3.38 3.38 0 0 0-1 1.25 1.34 1.34 0 0 0 .26 1.51 1.9 1.9 0 0 0 1.72.14c3.33-.9 6.27-3.06 9.68-3.56 1.78-.27 3.84-.16 5.08-1.47a5.33 5.33 0 0 0 1.08-2.23c.74-2.57 2.27-8 .72-10.5-.61-1-2.09-1.82-3-2.56a58.11 58.11 0 0 0-4.88-3.67Z",
    transform: "translate(-.01 -.02)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#w)",
    d: "M545.35 382.52a4.24 4.24 0 0 0-2-.87 1.5 1.5 0 0 0-1.64 1.13 2.23 2.23 0 0 0 .49 1.4l1.35 2.11a1.4 1.4 0 0 1 .29.76c-.05.7-1 .84-1.71.75-4.4-.56-8.79-1.93-13.18-1.34a1.39 1.39 0 0 0-.91.36 1 1 0 0 0 .11 1.26 2.73 2.73 0 0 0 1.18.67 50.66 50.66 0 0 0 7.55 2.12c-.29.72-1.24.84-2 .87a43.36 43.36 0 0 0-6.33.73c-1.19.22-2.65.81-2.66 2a1.9 1.9 0 0 0 1.43 1.68 6.05 6.05 0 0 0 2.36.08 38 38 0 0 1 8.26.21 16.33 16.33 0 0 0-8.12 3.3 1.7 1.7 0 0 0-.53.57 1.2 1.2 0 0 0 .84 1.48 3.61 3.61 0 0 0 1.9-.1 41.68 41.68 0 0 1 8.33-1.08 20.17 20.17 0 0 0-4.68 3 3.38 3.38 0 0 0-1 1.25 1.36 1.36 0 0 0 .26 1.51 1.92 1.92 0 0 0 1.73.14c3.32-.9 6.26-3.06 9.67-3.56 1.78-.27 3.84-.16 5.08-1.47a5.33 5.33 0 0 0 1.08-2.23c.75-2.57 2.27-8 .72-10.51-.61-1-2.09-1.81-3-2.55a58.11 58.11 0 0 0-4.87-3.67Z",
    transform: "translate(-.01 -.02)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebSecurity);
export default __webpack_public_path__ + "static/media/web-security.efa9017cfe58b472d8488bb3cb08bf11.svg";
export { ForwardRef as ReactComponent };